import { createFileRoute, redirect } from '@tanstack/react-router'
import {
  GlobalSearchParams,
  SEARCH_PARAM_ORG_ID,
} from 'routes/(global_search_params)/-searchParams'
import { createWalkthroughSearch } from 'routes/walkthrough/-searchParams'
import { Route as NewRoute } from 'routes/walkthrough/index'

export const Route = createFileRoute(
  '/walkthrough/(deprecated_routes)/$siteID'
)({
  beforeLoad: ({ params }) => {
    const siteId = params.siteID

    throw redirect({
      to: NewRoute.to,
      search: (prev: Record<string, unknown> & GlobalSearchParams) => ({
        ...prev,
        ...createWalkthroughSearch({
          orgId: prev[SEARCH_PARAM_ORG_ID],
          siteId,
        }),
      }),
      replace: true,
    })
  },
})
